import React, { useContext, useState } from "react";
import TagChipEditor from "../../../../../../CommonComponents/Tags/TagChipEditor";
import ColorPicker from "../../../../../../Elements/ColorPicker";
import { NavigatorContext } from "../../../../../../../utils/navigatorContext";
import { VALUE_FIELD_UI_DEFAULTS } from "../../../../../../../utils/helper";
import { resolveTags } from "../../../../../../../utils/resolveTags";
// import {handleSubmitBtnState} from "../../../editorHook/useEditorHook"
const TagSection = ({
  tool,
  handleChange,
  totalPages,
  setTool,
  errorState,
  toolType,
  editElement,
  docData,
  handleSubmitBtnState,
  mode, // 'all' (default) | 'color-only' | 'tags-only'
}) => {
  const { brandColors, addBrandColor, removeBrandColor } = useContext(NavigatorContext);
  const isHotspotElement =
    toolType === "HotspotToolbox" || editElement?.element_type === 9;
  const isAddImageModal = toolType === 'ImageToolbox' && !editElement?.id;
  const handleTagsChange = async (nextTags) => {
    const resolvedTags = await resolveTags(nextTags, tool?.tags || []);
    setTool((prevState) => ({
      ...prevState,
      tags: resolvedTags,
    }));
    handleSubmitBtnState();
  };



  if (mode === 'color-only') {
    return (
      <div className="color-select">
        <div className="d-flex align-items-center justify-content-between">
          <p>BACKGROUND</p>
          <ColorPicker
            color={tool?.value?.bg_color || VALUE_FIELD_UI_DEFAULTS.bg_color}
            name="bg_color"
            onChange={handleChange}
            alpha={true}
            brandColors={brandColors}
            onAddBrandColor={addBrandColor}
            onRemoveBrandColor={removeBrandColor}
          />
        </div>
      </div>
    );
  }

  if (mode === 'tags-only') {
    return (
      <>
        <div className={`tags-inp row ${isHotspotElement ? "hotspot-tags-row" : ""}`}>
          <div className="col-md-6 p-0">
            <div className={isHotspotElement ? "d-flex flex-column align-items-start hotspot-tags-container" : "d-flex align-items-start flex-column"}>
              <TagChipEditor
                tags={tool?.tags || []}
                onChange={handleTagsChange}
                minWidthCh={25}
                placeholderText="Please add a new Tag here"
                collapsible
              />
            </div>
          </div>
        </div>
        {(!tool?.tags || tool?.tags?.length == 0) && (
          <p className="text-danger">{errorState?.tagErr}</p>
        )}
      </>
    );
  }

  return (
    <>
      <div className={`tags-inp row ${isHotspotElement ? "hotspot-tags-row" : ""}`}>
        <div className="col-md-6 p-0 ">
          <div
            className={`${
              isHotspotElement
                ? "d-flex flex-column align-items-start hotspot-tags-container"
                : isAddImageModal
                ? "add-image-modal-tags"
                : "d-flex align-items-start flex-column"
            }`}
          >
            <TagChipEditor
              tags={tool?.tags || []}
              onChange={handleTagsChange}
              minWidthCh={25}
              placeholderText="Please add a new Tag here"
              collapsible
            />
          </div>
        </div>
      </div>
      {(!tool?.tags || tool?.tags?.length == 0) && (
        <p className="text-danger">{errorState?.tagErr}</p>
      )}
      {tool?.page == '' ? (
        <p className="text-danger text-end">Please add a valid page number </p>
      ) : tool?.page > totalPages ? (
        <p className="text-danger text-end">
          Please enter page from 1 to {totalPages}
        </p>
      ) : null}
    </>
  );
};
export default TagSection;
